<template>
    <div style="position: absolute; bottom: 0; width: 100%;">
        <div class="chat-tools">
            <div>
                <el-input type="textarea" :rows="1" placeholder="请输入信息" v-model="message">
                </el-input>
            </div>
            <el-row style="padding: 10px 0;">
                <el-col :span="3">
                    <img src="../../../../assets/img/chat/images/emoji.png" class="pickIcon" @click="openEmojis" />
                </el-col>
                <el-col :span="3">
                    <el-upload class="upload-demo" :action="baseUrl" :headers="uploadRequestHeader" :multiple="false"
                        accept="image/*" :limit="1" :show-file-list="false" :on-progress="onProgress"
                        :disabled="loading" :on-success="(e, data) => handleUploadSuccess(e, 1)"
                        :on-error="uploadError">
                        <img src="../../../../assets/img/chat/images/image.png" class="pickIcon" />
                    </el-upload>
                </el-col>
                <el-col :span="3">
                    <el-upload class="upload-demo" :action="baseUrl" :headers="uploadRequestHeader" :multiple="false"
                        accept="video/*" :limit="1" :show-file-list="false" :on-progress="onProgress"
                        :disabled="loading" :on-error="uploadError"
                        :on-success="(e, data) => handleUploadSuccess(e, 8)">
                        <img src="../../../../assets/img/chat/images/video.png" class="pickIcon" />
                    </el-upload>
                </el-col>
                <el-col :span="3">
                    <el-upload class="upload-demo" :action="baseUrl" :headers="uploadRequestHeader" :multiple="false"
                        :on-progress="onProgress" :limit="1" :show-file-list="false" :on-error="uploadError"
                        :disabled="loading" :on-success="(e, data) => handleUploadSuccess(e, 3)">
                        <img src="../../../../assets/img/chat/images/file.png" class="pickIcon" />
                    </el-upload>
                </el-col>
                <el-col :span="6">
                    <div style="color: #fff;">.</div>
                </el-col>
                <el-col :span="6">
                    <div class="sendBtn" @click="sendMsg">
                        <img v-if="!loading" src="../../../../assets/img/chat/images/send.png"
                            style="width: 20px; height: 20px; margin: 0 10px;" />
                        <i v-else class="el-icon-loading" style="font-size: 20px; color: #fff; margin-right: 10px;"></i>
                        <p>发送</p>
                    </div>
                </el-col>
            </el-row>
        </div>

        <div class="emojiBar" v-if="showEmojis">
            <ul style="list-style:none; padding:0; margin:0;">
                <li v-for="(item, index) in emojiList" :key="index" style="padding: 5px; float: left; cursor: pointer;">
                    <img style="width: 20px; height: 20px;" :src="getEmojiPath(item)" @click="emojiClick(item)" />
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { EMOJI_ICONS } from "../../../../assets/img/chat/images/emoji/emoji.js"
export default {
    name: "ChatTools",
    data() {
        return {
            message: "",
            emojiList: EMOJI_ICONS,
            showEmojis: false,
            baseUrl: `${localStorage.getItem('ownChatUrl')}/app/Chat/Upload/upload`,
            uploadRequestHeader: {
                Authorization: sessionStorage.getItem("token")
            }
        }
    },
    props: {
        loading: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        emojiClick(emoji) {
            this.message += ` face[${emoji}]`;
            this.showEmojis = false;
        },
        openEmojis() {
            this.showEmojis = !this.showEmojis;
        },
        sendMsg() {
            if (!this.loading) {
                this.$emit("sendMsg", this.message, 0);
            }
        },
        clearTextArea() {
            this.message = "";
            this.showEmojis = false;
        },
        handleUploadSuccess(res, type) {
            const link = res.data;
            this.$emit("sendMsg", link, type);
        },
        onProgress(e) {
            this.$emit("uploadStarted");
        },
        uploadError() {
            this.$message.error(this.$t("chat.messageFailed"))
            this.$emit("uploadError");
        },
        getEmojiPath(item) {
            switch (item) {
                case '亲亲':
                    return require(`../../../../assets/img/chat/images/emoji/emoji1.png`)
                case '偷笑':
                    return require(`../../../../assets/img/chat/images/emoji/emoji2.png`)
                case '可怜':
                    return require(`../../../../assets/img/chat/images/emoji/emoji3.png`)
                case '可爱':
                    return require(`../../../../assets/img/chat/images/emoji/emoji4.png`)
                case '吃惊':
                    return require(`../../../../assets/img/chat/images/emoji/emoji5.png`)
                case '哈哈':
                    return require(`../../../../assets/img/chat/images/emoji/emoji6.png`)
                case '委屈':
                    return require(`../../../../assets/img/chat/images/emoji/emoji7.png`)
                case '害羞':
                    return require(`../../../../assets/img/chat/images/emoji/emoji8.png`)
                case '微笑':
                    return require(`../../../../assets/img/chat/images/emoji/emoji9.png`)
                case '悲伤':
                    return require(`../../../../assets/img/chat/images/emoji/emoji10.png`)
                case '拜拜':
                    return require(`../../../../assets/img/chat/images/emoji/emoji11.png`)
                case '挖鼻':
                    return require(`../../../../assets/img/chat/images/emoji/emoji12.png`)
                case '爱你':
                    return require(`../../../../assets/img/chat/images/emoji/emoji13.png`)
                case '生病':
                    return require(`../../../../assets/img/chat/images/emoji/emoji14.png`)
                case '鄙视':
                    return require(`../../../../assets/img/chat/images/emoji/emoji15.png`)
                case '闭嘴':
                    return require(`../../../../assets/img/chat/images/emoji/emoji16.png`)
                case '馋嘴':
                    return require(`../../../../assets/img/chat/images/emoji/emoji17.png`)
                case '黑线':
                    return require(`../../../../assets/img/chat/images/emoji/emoji18.png`)
                case '鼓掌':
                    return require(`../../../../assets/img/chat/images/emoji/emoji19.png`)
                default:
                    return ''
            }
        },
    }
}
</script>

<style scoped>
.chat-tools {
    height: 100px;
    padding: 10px;
    border-top: 1px solid #dddddd;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.pickIcon {
    width: 27px;
    height: 27px;
    cursor: pointer;
}

.sendBtn {
    display: flex;
    margin-right: 10px;
    padding: 5px;
    background-color: #646566;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    background-color: var(--baseColor);
    cursor: pointer;
}

.emojiBar {
    padding: 10px;
    border: none;
    background-color: #fff;
    display: flex;
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/module/chat/components/chatTools.vue